import { render, staticRenderFns } from "./sortSvg.vue?vue&type=template&id=9bd53462&"
import script from "./sortSvg.vue?vue&type=script&lang=js&"
export * from "./sortSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports